import { useParams, Link } from 'react-router-dom';
import api from "../../../api/Api";
import { useEffect, useState } from 'react';
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

function Assets() {
  const { identy } = useParams();
  const [assets, setAssets] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setpageSize] = useState(8);
  const [sortField, setSortField] = useState("createdDate");
  const [sortOrder, setSortOrder] = useState("desc");

  const fetchAsset = (page) =>{
    api.post(
        "/api/assets/all/type", {
        search: search && search.trim() !== "" ? search : null
      },
        {
          params: {
            identy: identy,
            page: page,
            size: pageSize,
            sort: `${sortField},${sortOrder}`,
          }
        }
      )
      .then((res) => {
        setAssets(res.data.response.content);
        setTotalPages(res.data.response.totalPages);
      })
      .catch(console.error);
  };


    useEffect(() => {
    fetchAsset(page);
  }, [identy,page, sortField, sortOrder]);

 useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setPage(0); 
      fetchAsset(0);
    }, 100); 
    return () => clearTimeout(delayDebounce);
  }, [search]);

  const handlePageChange = (event, value) => {
    setPage(value - 1);
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  return (
    <div className="container-fluid mt-1 pt-2 d-flex flex-column" style={{height:'100%'}}>
      <div className='d-flex'>
        <Link to="/assets" className="btn btn-secondary m-3" style={{ height: "40px" }}>
          ← Back
        </Link>
        <div className='mt-3 me-2'>
          <h2 className='text-capitalize'>{ }</h2>
        </div>
        <input
          className="form-control rounded-pill p-3 ms-3 mt-2 mb-3"
          style={{ width: '60%', maxWidth: '600px', fontSize: '15px' }}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by asset name or id..."
        />
      </div>
      <div className='flex-grow-1' >
      <table className="table table-bordered">
        <thead className="table-primary">
          <tr>
            <th
              style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
              onClick={() => handleSort('assetName')}>
              Name {sortField === 'assetName' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
            </th>
            <th
              style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
              onClick={() => handleSort('assetId')}>
              Asset ID {sortField === 'assetId' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
            </th>
            <th
              style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
              onClick={() => handleSort('assetStatus')}>
              Status {sortField === 'assetStatus' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
            </th>
            <th
              style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
              onClick={() => handleSort('location')}>
              Asset Location {sortField === 'location' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
            </th>
            <th style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1 }}>
              View
            </th>
          </tr>
        </thead>
        <tbody>
          {assets.map((a) => (
              <tr key={a.identy}>
                <td>{a.assetName}</td>
                <td>{a.assetId}</td>
                
                <td className='text-capitalize'>{a.assetStatus.toLowerCase()}</td>
                <td>{a.location}</td>
                <td className="text-center">
                  <Link
                    to={`/assets/${a.identy}`}
                    className="custom-btn btn-sm"
                  >
                    View
                  </Link>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
            </div>
      {/* MUI Pagination */}
      <div className="d-flex justify-content-center mt-3 mb-2">
        <Stack spacing={2}>
          <Pagination
            count={totalPages}
            page={page + 1}  // convert 0-based -> 1-based
            onChange={handlePageChange}
            color="primary"
            shape="rounded"
            variant="outlined"
          />
        </Stack>
      </div>
    </div>
  );
}

export default Assets;
